<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="300px">
      <template v-slot:activator="{ on }">
        <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
        <v-btn color="gray" v-on="on" class="mx-0" fab small style="margin-top:10px;">
          <v-icon>mdi-comment-processing</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>{{ $t('common.comment') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 200px;">
          <v-textarea name="input-7-1" 
            v-model="comment"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false">{{ $t('common.close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="handleSaveComment">{{ $t('common.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from '@/services/api'
export default {
  props: {
    historyData: {
      type: Object,
      required: true
    },
    onFinished: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      dialogm1: "",
      dialog: false,
      comment: ''
    }
  },
  mounted() {
    if (this.historyData.Comment) this.comment = this.historyData.Comment
  },
  methods: {
    handleSaveComment() {
      const body = {
        PlayerID: this.historyData.PlayerID,
        Start: this.historyData.Start,
        Comment: this.comment
      }
      api.updateItem('pings', 'comment', body)
      .then(response => {
        this.onFinished()
        this.dialog = false
      })
    }
  }
}
</script>


